import { render, staticRenderFns } from "./AccommodationBody.vue?vue&type=template&id=5be99cd3&scoped=true&"
import script from "./AccommodationBody.vue?vue&type=script&lang=js&"
export * from "./AccommodationBody.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationBody.vue?vue&type=style&index=0&id=5be99cd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be99cd3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be99cd3')) {
      api.createRecord('5be99cd3', component.options)
    } else {
      api.reload('5be99cd3', component.options)
    }
    module.hot.accept("./AccommodationBody.vue?vue&type=template&id=5be99cd3&scoped=true&", function () {
      api.rerender('5be99cd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Visitors/Accommodation/AccommodationBody.vue"
export default component.exports